class SkuUpdater extends HTMLElement {
  connectedCallback() {
    const productDataAttr = this.getAttribute('product-data');
    if (!productDataAttr) return;

    this.productData = JSON.parse(productDataAttr);
    this.skuValueElement = this.querySelector('[data-sku-value]');
    if (!this.skuValueElement) return;

    document.addEventListener('theme:variant:change', (e) => {
      if (e.detail?.variant) {
        this.updateSKU(e.detail.variant.id);
      }
    });
  }

  updateSKU(variantId) {
    const variant = this.productData.variants.find(v => v.id == variantId);
    const sku = variant?.sku;
    
    if (sku) {
      this.skuValueElement.textContent = sku;
      this.style.display = '';
    } else {
      this.style.display = 'none';
    }
  }
}

if (!customElements.get('sku-updater')) {
  customElements.define('sku-updater', SkuUpdater);
}

